import { SvgProps } from "@/utils/types";

export const Store = ({
  primaryColor = "#F66E09",
  secondaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => (
  <svg
    width="32"
    height="27"
    viewBox="0 0 32 27"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3672 9.46484H2.28809V23.3369H28.3672V9.46484Z"
      fill={primaryColor}
    />
    <path
      d="M1.55371 5.98285V8.08347C1.75972 8.99187 2.57745 9.64549 3.51551 9.6591C4.47561 9.6727 5.3261 9.01289 5.53652 8.08347V5.98285H1.55371Z"
      fill={secondaryColor}
    />
    <path
      d="M3.54484 10.3665C3.53161 10.3665 3.51838 10.3665 3.50515 10.3665C2.22186 10.3479 1.13071 9.47291 0.850994 8.2374L0.833984 8.16196V5.27661H6.25696V8.16196L6.23995 8.23802C5.95897 9.47724 4.82939 10.3671 3.54484 10.3671V10.3665ZM2.27415 7.99747C2.43101 8.54659 2.94635 8.9442 3.52657 8.95286C3.53287 8.95286 3.53917 8.95286 3.54547 8.95286C4.13577 8.95286 4.65804 8.55772 4.81742 7.99747V6.6896H2.27415V7.99747Z"
      fill={outlineColor}
    />
    <path
      d="M5.80434 5.98285V8.08347C6.01035 8.99187 6.82808 9.64549 7.76614 9.6591C8.72624 9.6727 9.57673 9.01289 9.78715 8.08347V5.98285H5.80371H5.80434Z"
      fill={secondaryColor}
    />
    <path
      d="M7.79679 10.3665C7.78356 10.3665 7.77033 10.3665 7.7571 10.3665C6.47381 10.348 5.38266 9.47298 5.10295 8.23746L5.08594 8.16202V5.27667H10.5089V8.16202L10.4919 8.23808C10.2109 9.4773 9.08135 10.3671 7.79679 10.3671V10.3665ZM6.52547 7.99753C6.68234 8.54665 7.19767 8.94426 7.77789 8.95292C7.78419 8.95292 7.79049 8.95292 7.79679 8.95292C8.3871 8.95292 8.90936 8.55778 9.06875 7.99753V6.68966H6.52547V7.99753Z"
      fill={outlineColor}
    />
    <path
      d="M9.78872 5.98285V8.08347C9.99472 8.99187 10.8125 9.64549 11.7505 9.6591C12.7106 9.6727 13.5611 9.01289 13.7715 8.08347V5.98285H9.78809H9.78872Z"
      fill={secondaryColor}
    />
    <path
      d="M11.7792 10.3665C11.766 10.3665 11.7528 10.3665 11.7395 10.3665C10.4562 10.348 9.36508 9.47298 9.08537 8.23746L9.06836 8.16202V5.27667H14.4913V8.16202L14.4743 8.23808C14.1933 9.4773 13.0638 10.3671 11.7792 10.3671V10.3665ZM10.5085 7.99753C10.6654 8.54665 11.1807 8.94426 11.7609 8.95292C11.7672 8.95292 11.7735 8.95292 11.7798 8.95292C12.3701 8.95292 12.893 8.55778 13.0518 7.99753V6.68966H10.5085V7.99753Z"
      fill={outlineColor}
    />
    <path
      d="M13.8903 5.98285V8.08347C14.0963 8.99187 14.914 9.64549 15.8521 9.6591C16.8122 9.6727 17.6627 9.01289 17.8731 8.08347V5.98285H13.8896H13.8903Z"
      fill={secondaryColor}
    />
    <path
      d="M15.8827 10.3665C15.8695 10.3665 15.8563 10.3665 15.843 10.3665C14.5597 10.348 13.4686 9.47298 13.1889 8.23746L13.1719 8.16202V5.27667H18.5948V8.16202L18.5778 8.23808C18.2969 9.4773 17.1673 10.3671 15.8827 10.3671V10.3665ZM14.6114 7.99753C14.7683 8.54665 15.2836 8.94426 15.8638 8.95292C15.8701 8.95292 15.8764 8.95292 15.8827 8.95292C16.473 8.95292 16.9959 8.55778 17.1547 7.99753V6.68966H14.6114V7.99753Z"
      fill={outlineColor}
    />
    <path
      d="M17.8727 5.98285V8.08347C18.0787 8.99187 18.8964 9.64549 19.8345 9.6591C20.7946 9.6727 21.6451 9.01289 21.8555 8.08347V5.98285H17.8721H17.8727Z"
      fill={secondaryColor}
    />
    <path
      d="M19.8642 10.3665C19.8509 10.3665 19.8377 10.3665 19.8245 10.3665C18.5418 10.3479 17.45 9.47292 17.1703 8.23741L17.1533 8.16135V5.276H22.5763V8.16135L22.5593 8.23741C22.2783 9.47663 21.1487 10.3665 19.8642 10.3665ZM18.5935 7.99748C18.7504 8.54659 19.2657 8.94421 19.8459 8.95287C19.8522 8.95287 19.8585 8.95287 19.8648 8.95287C20.4551 8.95287 20.978 8.55772 21.1368 7.99748V6.68961H18.5935V7.99748Z"
      fill={outlineColor}
    />
    <path
      d="M21.8571 5.98285V8.08347C22.0631 8.99187 22.8808 9.64549 23.8189 9.6591C24.779 9.6727 25.6295 9.01289 25.8399 8.08347V5.98285H21.8564H21.8571Z"
      fill={secondaryColor}
    />
    <path
      d="M23.8486 10.3665C23.8353 10.3665 23.8221 10.3665 23.8089 10.3665C22.5256 10.348 21.4344 9.47298 21.1547 8.23746L21.1377 8.16202V5.27667H26.5607V8.16202L26.5437 8.23808C26.2627 9.4773 25.1331 10.3671 23.8486 10.3671V10.3665ZM22.5772 7.99753C22.7341 8.54665 23.2494 8.94426 23.8297 8.95292C23.836 8.95292 23.8423 8.95292 23.8486 8.95292C24.4389 8.95292 24.9611 8.55778 25.1205 7.99753V6.68966H22.5772V7.99753Z"
      fill={outlineColor}
    />
    <path
      d="M26.0182 5.98285V8.08347C26.2242 8.99187 27.0419 9.64549 27.98 9.6591C28.9401 9.6727 29.7906 9.01289 30.001 8.08347V5.98285H26.0176H26.0182Z"
      fill={secondaryColor}
    />
    <path
      d="M28.0097 10.3665C27.9965 10.3665 27.9832 10.3665 27.97 10.3665C26.6867 10.348 25.5956 9.47298 25.3158 8.23746L25.2988 8.16202V5.27667H30.7218V8.16202L30.7048 8.23808C30.4238 9.4773 29.2942 10.3671 28.0097 10.3671V10.3665ZM26.7384 7.99753C26.8952 8.54665 27.4106 8.94426 27.9908 8.95292C27.9971 8.95292 28.0034 8.95292 28.0097 8.95292C28.6 8.95292 29.1223 8.55778 29.2816 7.99753V6.68966H26.7384V7.99753Z"
      fill={outlineColor}
    />
    <path
      d="M11.9713 23.5317C11.9713 20.9691 11.9706 18.4066 11.9688 15.8446C11.9688 15.426 11.9687 15.0024 12.0721 14.5967C12.4608 13.0694 14.0521 11.9742 15.6277 12.0181C17.1416 12.0602 18.6429 13.1702 18.9837 14.6444C19.0788 15.0562 19.0807 15.4829 19.0814 15.9046C19.0864 18.4468 19.0801 20.9895 19.0801 23.5317"
      fill={secondaryColor}
    />
    <path
      d="M19.7545 23.5317H18.4056C18.4056 22.6128 18.4063 21.6939 18.4075 20.7744C18.4088 19.1783 18.4107 17.5279 18.4075 15.9053C18.4069 15.5262 18.4063 15.1341 18.3263 14.7897C18.0604 13.6408 16.8672 12.7138 15.6091 12.6786C14.3227 12.6427 13.0274 13.5746 12.7269 14.7557C12.6431 15.0847 12.6431 15.4532 12.6437 15.8428C12.6456 18.4054 12.6463 20.9679 12.6463 23.5305H11.2974C11.2974 20.9679 11.2968 18.406 11.2949 15.8434C11.2949 15.4112 11.2949 14.922 11.4184 14.4341C11.8714 12.6538 13.7317 11.3021 15.6469 11.3546C17.5224 11.4066 19.2398 12.7571 19.6417 14.496C19.7545 14.9839 19.7551 15.4712 19.7563 15.9016C19.7595 17.526 19.7582 19.1771 19.7563 20.7744C19.7557 21.6933 19.7545 22.6116 19.7545 23.5305V23.5317Z"
      fill={outlineColor}
    />
    <path
      d="M29.9527 25.0498C29.9527 25.3677 29.8198 25.6614 29.6037 25.8729C29.3876 26.085 29.0928 26.2155 28.7645 26.2155H2.42645C1.77125 26.2155 1.23828 25.6886 1.23828 25.0492C1.23828 24.7277 1.37121 24.4346 1.5873 24.2225C1.80338 24.0104 2.09822 23.8799 2.42645 23.8799H28.7645C29.4197 23.8799 29.9527 24.4061 29.9527 25.0492V25.0498Z"
      fill={primaryColor}
    />
    <path
      d="M28.7641 26.9259H2.42604C1.37207 26.9259 0.514648 26.0843 0.514648 25.0498C0.514648 24.5477 0.713726 24.0758 1.07597 23.7209C1.43822 23.3659 1.91764 23.1699 2.42604 23.1699H28.7641C29.8181 23.1699 30.6755 24.0134 30.6755 25.0498C30.6755 25.5494 30.4764 26.02 30.1142 26.375C29.7519 26.7299 29.2725 26.9259 28.7641 26.9259ZM2.42604 24.5903C2.26918 24.5903 2.16145 24.6639 2.09845 24.7251C2.01025 24.8117 1.96111 24.9273 1.96111 25.0498C1.96111 25.2971 2.17405 25.5061 2.42604 25.5061H28.7641C28.921 25.5061 29.0287 25.4326 29.0917 25.3713C29.1787 25.286 29.2291 25.1685 29.2291 25.0504C29.2291 24.7969 29.0205 24.591 28.7641 24.591H2.42604V24.5903Z"
      fill={outlineColor}
    />
    <path
      d="M3.50441 9.65961H1.86328V23.5316H3.50441V9.65961Z"
      fill={outlineColor}
    />
    <path
      d="M29.1764 10.0128H27.5566V23.5311H29.1764V10.0128Z"
      fill={outlineColor}
    />
    <path
      d="M30.4495 1.81928V4.63908C30.4495 5.18696 29.9922 5.62848 29.4289 5.62848H1.86238C1.29917 5.62848 0.841797 5.18696 0.841797 4.63908V1.81928C0.841797 1.2714 1.29917 0.826172 1.86238 0.826172H29.4296C29.9928 0.826172 30.4502 1.2714 30.4502 1.81928H30.4495Z"
      fill={primaryColor}
    />
    <path
      d="M29.4295 6.45523H1.86289C0.836 6.45523 0 5.64083 0 4.63906V1.81926C0 0.816257 0.83537 0 1.86289 0H29.4301C30.457 0 31.293 0.816257 31.293 1.81926V4.63906C31.293 5.64021 30.4576 6.45523 29.4301 6.45523H29.4295ZM1.86289 1.65292C1.76461 1.65292 1.6846 1.72774 1.6846 1.81926V4.63906C1.6846 4.72872 1.76461 4.80169 1.86289 4.80169H29.4301C29.5284 4.80169 29.6084 4.72872 29.6084 4.63906V1.81926C29.6084 1.72774 29.5284 1.65292 29.4301 1.65292H1.86289Z"
      fill={outlineColor}
    />
    <path
      d="M16.9665 19.2154C16.5904 19.2154 16.2842 18.9149 16.2842 18.5457C16.2842 18.1766 16.5904 17.876 16.9665 17.876C17.3426 17.876 17.6487 18.1766 17.6487 18.5457C17.6487 18.9149 17.3426 19.2154 16.9665 19.2154Z"
      fill={outlineColor}
    />
  </svg>
);
